import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';
import { DocumentUploadDragger } from '@/components';
import { FilterImportStatus } from '@/models/filters.model';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem;
`;

export const StyledTabsWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: flex-end;
`;

export const StyledTitleModal = styled.p`
  ${pickThemeFontStyles('20', '24', 'SEMI_BOLD')};
  margin-bottom: 2rem;
`;

export const StyledButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;

  &&& {
    button {
      ${pickThemeFontStyles('14', '22', 'BOLD')};
      width: 100%;
      color: ${COLORS.WHITE};
    }
  }
`;

export const StyledCreateButton = styled(Button)`
  &&& {
    max-width: 13rem;
    height: 2.125rem;

    svg {
      fill: ${COLORS.BLACK};
    }
  }
`;

export const StyledPageTitle = styled.div`
  ${pickThemeFontStyles('24', '30', 'SEMI_BOLD')};
  color: ${COLORS.BLACK};
`;

export const StyledHeaderBlock = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 2rem;
`;

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  margin-top: 2rem;
  flex-direction: column;
`;

export const StyledImportTitle = styled.div`
  ${pickThemeFontStyles('18', '24', 'SEMI_BOLD')};
  color: ${COLORS.BLACK};
  margin-bottom: 1rem;
`;

export const StyledImportBlock = styled.div`
  max-width: 38rem;
  margin-top: 3rem;
`;

export const StyledUploadContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 1.5rem;
  border: 1px dashed ${COLORS.IRON_GRAY};
  border-radius: 0.5rem;
  background-color: ${COLORS.GRAY};
  transition: border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
  ${pickThemeFontStyles('14', '18')};

  svg {
    margin-right: 0.5rem;
  }
`;

export const StyledDragger = styled(DocumentUploadDragger)`
  padding: 0 !important;
`;

export const StyledContinueBlock = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem;
  background-color: ${COLORS.GRAY};
  border-radius: 0.5rem;
  margin-top: 1rem;
`;

export const StyledButtonsWrap = styled.div`
  display: flex;
  gap: 1rem;
`;

export const StyledButton = styled(Button)`
  width: 100%;
  svg {
    margin-right: 0.5rem;
  }
`;

export const StyledStatus = styled.div`
  display: flex;
  margin-bottom: 1rem;
  align-items: center;
  gap: 1rem;
`;

export const StyledBadge = styled.div<{ $status?: FilterImportStatus }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  padding: 0.25rem 0.75rem;
  height: 1.5rem;
  gap: 0.5rem;
  border-radius: 1.6rem;
  border: 1px solid ${COLORS.BRIGHT_GRAY};
  background: ${COLORS.GRAY};

  .indicator {
    border-radius: 50%;
    height: 0.75rem;
    width: 0.75rem;
    background: ${({ $status }) => {
      switch ($status) {
        case FilterImportStatus.FAILED:
          return COLORS.RED;
        case FilterImportStatus.PROCESSING:
          return COLORS.ORANGE;
        case FilterImportStatus.FINISHED:
          return COLORS.GREEN;
      }
    }};
  }
`;
